import React from 'react';
import { Container } from '@mui/material';
import {
    DossierRoutingProvider,
    dossiersBasePath,
    SelectedOrderProvider,
} from '@europrocurement/l2d-modules';
import { DetailOrderHeader, OrderBody } from '../../components';
import { ordersBasePath } from '../../constants';

const OrderDetail: React.FunctionComponent = function () {
    return (
        <DossierRoutingProvider
            orderBasePath={ordersBasePath}
            dossierBasePath={dossiersBasePath}
        >
            <SelectedOrderProvider>
                <Container maxWidth="lg">
                    <DetailOrderHeader />
                    <OrderBody />
                </Container>
            </SelectedOrderProvider>
        </DossierRoutingProvider>
    );
};

export default OrderDetail;
